/**
 * PROJECT-TEMPLATE.WIDGET
 * Display all topics for a template
 */

import { openEditorFromProject } from "@/utils/editor-origin.utils"
import { withTranslation, WithTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useState } from "react"
import { store } from "@/index"
import { TemplateState } from "@/redux/template.types"
import { AxisState } from "@/redux/axis.types"
import ListItem from "@/components/list-item"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretRight, faClipboardList, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons"
import { TopicState } from "@/redux/topic.types"
import SelectTemplateModal from "@/modals/select-template.modal"
import ListIcon from "@/components/list-icon"
import {
  projectEdit
  // projectStatus
} from "@/redux/project.actions"
import Link from "@/components/link"
import ConfirmButtons from "@/components/confirm-buttons"
import { ProjectState } from "@/redux/project.types"
import Space from "@/components/space"
import Button from "@/components/button"
import ProjectStepErrorsWidget from "./project-step-errors.widget"
import { NavigateFunction, useNavigate } from "react-router-dom"
// import Checkbox from "@/components/checkbox"
// import { accountUpdateOptions } from "@/redux/account.actions"
// import { sessionEditAccountOptions } from "@/redux/_session.actions"
import { Session } from "@/redux/_session.types"
// import { STATUS_SAVED, STATUS_SAVING } from "@/redux/_status.types"

interface StateProps extends WithTranslation {
  axis: AxisState
  project: ProjectState
  template: TemplateState
  topic: TopicState
  _session: Session
}

interface OwnProps {
  onNext: Function
  onEdit: Function
}

type Props = StateProps & OwnProps

const MODAL_SWITCH_TEMPLATE = "MODAL_SWITCH_TEMPLATE"

function ProjectTemplateWidget(props: Props) {
  const { t } = props
  const navigate: NavigateFunction = useNavigate()

  //Modal to display
  const [currentModal, setCurrentModal] = useState<string | null>(null)

  //Authorize users see their results
  // const [authorizeSeeResults, setAuthorizeSeeResults] = useState<boolean>(
  //   props._session.accountOptions.authorizeSeeResults ?? false
  // )

  // async function authorizeResults() {
  //   const newValue = !authorizeSeeResults
  //   setAuthorizeSeeResults(newValue)

  //   store.dispatch(projectStatus(STATUS_SAVING))

  //   // Update dans Redux
  //   store.dispatch(sessionEditAccountOptions("authorizeSeeResults", newValue))

  //   // Met à jour côté serveur
  //   await store.dispatch(
  //     accountUpdateOptions({
  //       ...props._session.accountOptions,
  //       authorizeSeeResults: newValue
  //     })
  //   )

  //   store.dispatch(projectStatus(STATUS_SAVED))
  // }

  //Reset values
  function cancel() {
    store.dispatch(projectEdit("TemplateId", null))
    select()
    next(false, false)
  }

  function next(isVisited, isConfirmed) {
    props.onNext(isVisited, isConfirmed)
  }

  function select() {
    props.onEdit()
  }

  //Select another template
  //Reset populations by axes settings
  function selectTemplate(templateId) {
    store.dispatch(projectEdit("TemplateId", templateId))
    store.dispatch(projectEdit("segmentationByAxesRules", []))
    select()
  }

  return (
    <div>
      {currentModal === MODAL_SWITCH_TEMPLATE && (
        <SelectTemplateModal
          onClose={() => setCurrentModal(null)}
          onSelect={(templateId) => {
            setCurrentModal(null)
            selectTemplate(templateId)
          }}
        />
      )}

      <ListItem>
        <div className="setup-card-help">
          <p>{t("project_template_help")}</p>
          <div className="grey-t setup-card-help-content">
            <p>{t("project_template_help_2")}</p>
          </div>
        </div>
      </ListItem>

      <ListItem>
        <ListIcon fallbackIcon={faClipboardList} image={props.template.active.imageUrl} />

        <div className="flex1">
          <div style={{ marginBottom: !props.project.active.isLaunch ? 22 : 0 }} className="flex flex1">
            {props.template.active.id.length > 0 ? (
              <b>{props.template.active.label}</b>
            ) : (
              <div className="flex flex1">
                <b>{t("template_empty")}</b>
                <Space />
                <div id="template-select">
                  <Button className="primary" onClick={() => setCurrentModal(MODAL_SWITCH_TEMPLATE)}>
                    {t("survey_template_select")}
                  </Button>
                </div>
              </div>
            )}
          </div>

          {!props.project.active.isLaunch && (
            <div>
              <Link
                className={props.project.active.alerts.template.errors.length > 0 ? "red-t" : undefined}
                icon={faCaretRight}
                onClick={() => openEditorFromProject(navigate)}>
                {t("template_edit")}
                {props.project.active.alerts.template.errors.length > 0 && (
                  <FontAwesomeIcon icon={faExclamationTriangle} className="ml-2" />
                )}
              </Link>

              <Link icon={faCaretRight} onClick={() => setCurrentModal(MODAL_SWITCH_TEMPLATE)}>
                {t("template_switch")}
              </Link>
            </div>
          )}
        </div>
      </ListItem>

      <ProjectStepErrorsWidget alert={props.project.active.alerts.template} step="template" />

      <ConfirmButtons
        isLocked={props.project.active.alerts.template.errors.length > 0}
        onCancel={() => cancel()}
        onConfirm={() => next(true, true)}
        onConfirmLater={() => next(true, false)}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  axis: state.axis,
  project: state.project,
  template: state.template,
  topic: state.topic,
  _session: state._session
})

export default connect(mapStateToProps)(withTranslation()(ProjectTemplateWidget))
